import { render, staticRenderFns } from "./Protocal.vue?vue&type=template&id=a2981d6c&scoped=true&"
import script from "./Protocal.vue?vue&type=script&lang=js&"
export * from "./Protocal.vue?vue&type=script&lang=js&"
import style0 from "./Protocal.vue?vue&type=style&index=0&id=a2981d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2981d6c",
  null
  
)

export default component.exports